import React from "react";
import resumeFile from "../documents/resume.pdf";

const Resume = () => {
  const educationDetails = [
    {
      yearRange: "2016 - 2018",
      title: "Master of Business Administration (M.B.A.)",
      place: "UCLA Anderson School of Management",
      desc: "Specialized in Business Administration and Management, strengthening strategic finance, leadership, and organizational growth capabilities.",
    },
  ];

  const experienceDetails = [
    {
      yearRange: "2025 - Present",
      title: "Entrepreneur & Investor",
      place: "Industrial & Service Sectors",
      desc: "Acquiring and scaling businesses in industrial services, air filtration, dust collection, logistics, and environmental sectors with a focus on long-term value creation.",
    },
    {
      yearRange: "2018 - Present",
      title: "Chief Financial Officer",
      place: "Team Rubicon",
      desc: "Executive team member advising the CEO and Board on all financial matters. Oversaw FP&A, treasury, audit, compliance, risk management, and built a top-tier internal finance team.",
    },
    {
      yearRange: "2012 - 2018",
      title: "Finance Director — Canada & Mexico",
      place: "Warner Bros. Entertainment",
      desc: "Managed full P&L, balance sheet, and cash flow across Canada and Mexico. Led annual operating budgets, reforecasts, and strategic financial modeling for the regional executive team.",
    },
    {
      yearRange: "2006 - 2012",
      title: "Director of Financial Planning & Analysis",
      place: "Warner Bros. Entertainment",
      desc: "Led global forecast process, quarterly finance reviews with Division President & CFO, and the Annual Operating Plan. Drove operating margin improvements and cost-saving initiatives.",
    },
    {
      yearRange: "2003 - 2006",
      title: "Manager of Financial Planning & Analysis",
      place: "Warner Bros. Entertainment",
      desc: "Managed FP&A operations, supported budgeting cycles, and developed analytical tools to track KPIs and drive management decision-making.",
    },
    {
      yearRange: "1988 - 1993",
      title: "Military Service",
      place: "United States Marine Corps",
      desc: "Five years of service developing leadership, discipline, and operational execution under high-pressure environments.",
    },
  ];

  const skills = [
    {
      name: "Financial Strategy & FP&A",
      percent: 98,
    },
    {
      name: "M&A & Turnarounds",
      percent: 90,
    },
    {
      name: "Capital & Treasury Management",
      percent: 92,
    },
    {
      name: "Board & Investor Relations",
      percent: 88,
    },
    {
      name: "Operational Excellence",
      percent: 85,
    },
    {
      name: "ERP & Digital Transformation",
      percent: 78,
    },
  ];
  // const educationDetails = [
  //   {
  //     yearRange: "2015 - 2017",
  //     title: "Master in Computer Engineering",
  //     place: "Harvard University",
  //     desc: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the dummy text.",
  //   },
  //   {
  //     yearRange: "2014 - 2015",
  //     title: "Bachelor in Computer Engineering",
  //     place: "University of California",
  //     desc: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the dummy text.",
  //   },
  //   {
  //     yearRange: "2013 - 2014",
  //     title: "International Science",
  //     place: "Harvard University",
  //     desc: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the dummy text.",
  //   },
  // ];

  // const experienceDetails = [
  //   {
  //     yearRange: "2020 - current",
  //     title: "Sr. Font End Developer",
  //     place: "Apple Inc",
  //     desc: "Lisque persius interesset his et, in quot quidam persequeris vim, ad mea essent possim iriure.",
  //   },
  //   {
  //     yearRange: "2018 - 2020",
  //     title: "Jr. Font End Developer",
  //     place: "Dribbble Inc",
  //     desc: "Lisque persius interesset his et, in quot quidam persequeris vim, ad mea essent possim iriure.",
  //   },
  //   {
  //     yearRange: "2017 - 2018",
  //     title: "HTML Developer",
  //     place: "Adobe Inc",
  //     desc: "Lisque persius interesset his et, in quot quidam persequeris vim, ad mea essent possim iriure.",
  //   },
  // ];

  // const skills = [
  //   {
  //     name: "Web Design",
  //     percent: 65,
  //   },
  //   {
  //     name: "HTML/CSS",
  //     percent: 95,
  //   },
  //   {
  //     name: "JavaScript",
  //     percent: 80,
  //   },
  //   {
  //     name: "React JS",
  //     percent: 70,
  //   },
  //   {
  //     name: "Angular Js",
  //     percent: 60,
  //   },
  //   {
  //     name: "Bootstrap",
  //     percent: 99,
  //   },
  // ];

  // return (
  //   <section id="resume" className="section">
  //     <div className="container">
  //       {/* Heading */}
  //       <p className=" text-center mb-2 wow fadeInUp">
  //         <span className="bg-primary text-dark px-2">Resume</span>
  //       </p>
  //       <h2 className="text-10 fw-600 text-center mb-5 wow fadeInUp">
  //         A summary of My Resume
  //       </h2>
  //       {/* Heading end*/}
  //       <div className="row g-5 mt-5">
  //         {/* My Education */}
  //         <div className="col-lg-6 wow fadeInUp">
  //           <h2 className="text-7 fw-600 mb-4 pb-2">My Education</h2>
  //           <div className="border-start border-2 border-primary ps-3">
  //             {educationDetails.length > 0 &&
  //               educationDetails.map((value, index) => (
  //                 <div key={index}>
  //                   <h3 className="text-5">{value.title}</h3>
  //                   <p className="mb-2">
  //                     {value.place} / {value.yearRange}
  //                   </p>
  //                   <p className="text-muted">{value.desc}</p>
  //                   <hr className="my-4" />
  //                 </div>
  //               ))}
  //           </div>
  //         </div>
  //         {/* My Experience */}
  //         <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.2s">
  //           <h2 className="text-7 fw-600 mb-4 pb-2">My Experience</h2>
  //           <div className="border-start border-2 border-primary ps-3">
  //             {experienceDetails.length > 0 &&
  //               experienceDetails.map((value, index) => (
  //                 <div key={index}>
  //                   <h3 className="text-5">{value.title}</h3>
  //                   <p className="mb-2">
  //                     {value.place} / {value.yearRange}
  //                   </p>
  //                   <p className="text-muted">{value.desc}</p>
  //                   <hr className="my-4" />
  //                 </div>
  //               ))}
  //           </div>
  //         </div>
  //       </div>
  //       {/* My Skills */}
  //       <h2 className="text-7 fw-600 mb-4 pb-2 mt-5 wow fadeInUp">My Skills</h2>
  //       <div className="row gx-5">
  //         {skills.length > 0 &&
  //           skills.map((skill, index) => (
  //             <div className="col-md-6 wow fadeInUp" key={index}>
  //               <p className="fw-500 text-start mb-2">
  //                 {skill.name}{" "}
  //                 <span className="float-end">{skill.percent}%</span>
  //               </p>
  //               <div className="progress progress-sm mb-4">
  //                 <div
  //                   className="progress-bar"
  //                   role="progressbar"
  //                   style={{ width: skill.percent + "%" }}
  //                   aria-valuenow={skill.percent}
  //                   aria-valuemin={0}
  //                   aria-valuemax={100}
  //                 />
  //               </div>
  //             </div>
  //           ))}
  //       </div>
  //       <p className="text-center mt-5 wow fadeInUp">
  //         <a
  //           className="btn btn-outline-dark shadow-none rounded-0"
  //           href={resumeFile}
  //           download
  //         >
  //           Download CV
  //         </a>
  //       </p>
  //     </div>
  //   </section>
  // );

  return (
    <section id="resume" className="section">
      <div className="container">
        {/* Heading */}
        <p className="text-center mb-2 wow fadeInUp">
          <span className="bg-primary px-2" style={{ color: "white" }}>
            Resume
          </span>
        </p>
        <h2 className="text-10 fw-600 text-center mb-5 wow fadeInUp">
          A Summary of My Resume
        </h2>

        <div className="row g-5 mt-5">
          {/* Left Column — Education + first 3 Experience */}
          <div className="col-lg-6 wow fadeInUp">
            <h2 className="text-7 fw-600 mb-4 pb-2">My Education</h2>
            <div className="border-start border-2 border-primary ps-3">
              {educationDetails.map((value, index) => (
                <div key={index}>
                  <h3 className="text-5">{value.title}</h3>
                  <p className="mb-2">
                    {value.place} / {value.yearRange}
                  </p>
                  <p className="text-muted">{value.desc}</p>
                </div>
              ))}
            </div>

            <h2 className="text-7 fw-600 mb-4 pb-2 mt-5">My Experience</h2>
            <div className="border-start border-2 border-primary ps-3">
              {experienceDetails.slice(0, 3).map((value, index) => (
                <div key={index}>
                  <h3 className="text-5">{value.title}</h3>
                  <p className="mb-2">
                    {value.place} / {value.yearRange}
                  </p>
                  <p className="text-muted">{value.desc}</p>
                  {index < 1 && <hr className="my-4" />}
                </div>
              ))}
            </div>
          </div>

          {/* Right Column — remaining 3 Experience */}
          <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.2s">
            {/* <h2 className="text-7 fw-600 mb-4 pb-2">Continued</h2> */}
            <div className="border-start border-2 border-primary ps-3">
              {experienceDetails.slice(2).map((value, index, arr) => (
                <div key={index}>
                  <h3 className="text-5">{value.title}</h3>
                  <p className="mb-2">
                    {value.place} / {value.yearRange}
                  </p>
                  <p className="text-muted">{value.desc}</p>
                  {index < arr.length - 1 && <hr className="my-4" />}
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* My Skills */}
        <h2 className="text-7 fw-600 mb-4 pb-2 mt-5 wow fadeInUp">My Skills</h2>
        <div className="row gx-5">
          {skills.map((skill, index) => (
            <div className="col-md-6 wow fadeInUp" key={index}>
              <p className="fw-500 text-start mb-2">
                {skill.name}
                <span className="float-end">{skill.percent}%</span>
              </p>
              <div className="progress progress-sm mb-4">
                <div
                  className="progress-bar"
                  role="progressbar"
                  style={{ width: skill.percent + "%" }}
                  aria-valuenow={skill.percent}
                  aria-valuemin={0}
                  aria-valuemax={100}
                />
              </div>
            </div>
          ))}
        </div>

        {/* <p className="text-center mt-5 wow fadeInUp">
        <a
          className="btn btn-outline-dark shadow-none rounded-0"
          href={resumeFile}
          download
        >
          Download CV
        </a>
      </p> */}
      </div>
    </section>
  );
};

export default Resume;
